/**
 * Example appState - vuex module
 */
import { MutationTree, ActionTree, GetterTree } from 'vuex';

import { ILyraStoreState, ILyraObject } from '../@types';

/**
 * State
 */
const state: ILyraStoreState = {
	appManager: [],
	assets: [],
	citations: [],
	debug: false,
	$lyra: {},
};

/**
 * Mutations
 */
const mutations: MutationTree<ILyraStoreState> = {
	updateAppManager (stateObj: ILyraStoreState, appManager: any[]) {
		stateObj.appManager = appManager;
	},
	updateAssets (stateObj: ILyraStoreState, assets: any[]) {
		stateObj.assets = assets;
	},
	updateCitations (stateObj: ILyraStoreState, citations: any[]) {
		stateObj.citations = citations;
	},
	updateDebugging (stateObj: ILyraStoreState, debug: boolean) {
		stateObj.debug = debug;
	},
	updateLyraInstance (stateObj: ILyraStoreState, $lyra: ILyraObject) {
		stateObj.$lyra = $lyra;
	},
};

/**
 * Getters
 */
const getters: GetterTree<ILyraStoreState, any> = {
	get_appManager (stateObj: ILyraStoreState): any[] {
		return stateObj.appManager;
	},
	get_assets (stateObj: ILyraStoreState): any[] {
		return stateObj.assets;
	},
	get_citations (stateObj: ILyraStoreState): any[] {
		return stateObj.citations;
	},
	get_debug (stateObj): boolean {
		return stateObj.debug;
	},
	get_$lyra (stateObj): ILyraObject {
		return stateObj.$lyra;
	},
};

/**
 * Actions
 */
const actions: ActionTree<ILyraStoreState, any> = {
	axn_updateAppManager (context: any, appManager: any[]) {
		context.commit('updateAppManager', appManager);
	},
	axn_updateAssets (context: any, assets: any[]) {
		context.commit('updateAssets', assets);
	},
	axn_updateCitations (context: any, citations: any[]) {
		context.commit('updateCitations', citations);
	},
	axn_updateDebugging (context, debug: boolean) {
		context.commit('updateDebugging', debug);
	},
	axn_updateLyraInstance (context, $lyra: ILyraObject) {
		context.commit('updateLyraInstance', $lyra);
	},
};

/**
 * Export
 */
export default {
	namespace: true,
	state,
	mutations,
	getters,
	actions,
};
